import { FwVersionContentAndMetadata, Service } from 'src/dtos/version.dto';
import axiosService from './axios-service';
import { ServicesUpdateDto } from '../dtos/default-service-update.dto';

class ServiceService {

    public createNewCustomService = async (customerId: number, sid: number, externalId: string, service: Service): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${sid}/service`, {
            externalId,
            ...service
        });
        return result?.data;
    };

    public updateCustomService = async (customerId: number, sid: number, externalId: string, updatedService: Service, originalDisplayName: string)
        : Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/service`, {
            externalId,
            ...updatedService,
            originalDisplayName
        });
        return result?.data;
    };

    public deleteCustomService = async (customerId: number, sid: number, externalId: string, objectDisplayName: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${sid}/service`, {
            externalId,
            objectDisplayName
        });
        return result?.data;
    };

    public editDefaultService = async (customerId: number, sid: number, externalId: string, defaultServiceUpdateDto: ServicesUpdateDto)
        : Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/default-service`, {
            externalId,
            ...defaultServiceUpdateDto
        });
        return result?.data;
    };
}

const serviceService = new ServiceService();
export default serviceService;